var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcoli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 194,
    viewBox: "0 0 96 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-ecoli"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 194
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ecoli",
    clipPath: "url(#clip-ecoli)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(16 20)",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,.5C44.673.5,58.5,8.327,58.5,26L56,122c0,17.673-3.827,35-21.5,35s-19-9.827-19-27.5L7,38C7,20.327,9.327.5,27,.5Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27 4.5 C 23.68984222412109 4.5 21.03970336914063 5.322097778320313 18.8981819152832 7.013275146484375 C 16.93531799316406 8.563339233398438 15.32093048095703 10.93899536132813 14.0998649597168 14.07423400878906 C 11.34609985351563 21.14488220214844 11.00592422485352 30.96848297119141 11.00008010864258 37.81555938720703 L 19.48284149169922 129.1300048828125 L 19.5 129.3146057128906 L 19.5 129.5 C 19.5 136.9219055175781 19.68243026733398 143.9189147949219 21.88547897338867 147.9644165039063 C 22.7859992980957 149.6180725097656 24.01190948486328 150.7583160400391 25.74352264404297 151.5528411865234 C 27.83636474609375 152.5131072998047 30.78245544433594 153 34.5 153 C 41.05436325073242 153 45.43211364746094 150.262451171875 48.2769775390625 144.3847503662109 C 49.58295440673828 141.6865234375 50.5572509765625 138.2981872558594 51.17279434204102 134.3138580322266 C 51.7216796875 130.7610168457031 52 126.6180419921875 52 122 L 52 121.9479370117188 L 52.00136566162109 121.8958587646484 L 54.49995422363281 25.94993591308594 C 54.49372863769531 22.30281066894531 53.81060409545898 19.06137084960938 52.46927261352539 16.31541442871094 C 51.2277717590332 13.77377319335938 49.39029693603516 11.59689331054688 47.0079345703125 9.845245361328125 C 42.25193023681641 6.348358154296875 35.33329772949219 4.5 27 4.5 M 27 0.5 C 44.67311096191406 0.5 58.5 8.326889038085938 58.5 26 L 56 122 C 56 139.6731109619141 52.17311477661133 157 34.5 157 C 16.82688522338867 157 15.5 147.1731109619141 15.5 129.5 L 7 38 C 7 20.32688903808594 9.326885223388672 0.5 27 0.5 Z",
    stroke: "none",
    fill: "#8ac926"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoli);
export default __webpack_public_path__ + "static/media/ecoli.b63aafe6.svg";
export { ForwardRef as ReactComponent };